import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsBaseField from "./_imports/forms-base-field.vue";

export default {
	name: 'forms-submit-button',
	template: getVueTemplate('forms-submit-button'),
	mixins: [
		FormsBaseField
	],
	data() {
		return {
			isDisabled: true,
			loaderAttribute: null
		};
	},
    computed: {
        buttonLabel() {
            return this.form?.submitLabel || this.field.value;
        },
        loaderAttributeValue() {
            return this.field.loader || 'btn-primary';
        }
    },
	created() {
		this.updateState(state => {
			state.ignore = true;
			state.formSubmitLabel = this.buttonLabel
		});

		this.$emit('update-form-submit-label', this.buttonLabel);
		this.$root.$emit('update-form-submit-label', this.buttonLabel);
	},
	watch: {
		formState() {
			this.handleFormSubmitting();
		}
	},
	methods: {
		handleFormSubmitting() {
			this.loaderAttribute = this.formState.formIsSubmitting ? 'am-loader' : null;
		}
	}
};